module.exports = __webpack_public_path__ + "static/img/bg-item2.73ca3e1d.png";